import { getBlockName } from '../helpers'
import { countBlockErrors } from '../hooks/useBlockErrors/helpers'
import { compareLayoutItems } from '../hooks/useTrackingPageLayout/helpers'

export const getLayoutErrorRows = ({ layout, layoutErrors, blockSettings, t }) => {
  return [...layout]
    .sort(compareLayoutItems)
    .filter(item => layoutErrors[item.i])
    .map(item => {
      return {
        blockId: item.i,
        name: getBlockName(item.i, blockSettings, t),
        errorCount: countBlockErrors(layoutErrors[item.i]),
      }
    })
}

export const getLayoutErrorsDescriptionKey = count => {
  if (count === 1) return 'Faltan campos obligatorios en {{count}} bloque. Corrígelos para poder guardar los cambios.'

  return 'Faltan campos obligatorios en {{count}} bloques. Corrígelos para poder guardar los cambios.'
}
